import React from 'react';
import { Link } from 'react-router-dom';
import { useUI } from '../../DataStore/UIContext';
import LicenseBillingAlert from '../Config/LicenseBillingAlert';
import { useAuth } from '../../DataStore/AuthContext';

const PageHeader = ({
  title,
  breadcrumb = null,
  primaryButtons = [],
  dropdown = null
}) => {

    const { currentNotify } = useUI();
    const { licenseInfo, unpaidInvoice } = useAuth();
    const currentPage = window.location.pathname || '';

  return (
    <>
    <div className="page-header">
      <div>
        <h2 className="main-content-title tx-24 mg-b-5">{title}</h2>
        {breadcrumb && <ol className="breadcrumb">{breadcrumb}</ol>}
      </div>

      <div className="btn btn-list large-display">
        {primaryButtons.map((btn, index) => (
          <a key={index} className={`btn ripple ${btn.className}`} href={btn.href || "#"} onClick={btn.onClick}>
            <i className={`${btn.icon}`}></i> {btn.label}
          </a>
        ))}

        {dropdown && (
          <>
            <Link
              className={`btn ripple ${dropdown.buttonClass || 'btn-danger'} dropdown-toggle`}
              to="#"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <i className={dropdown.icon || 'fe fe-settings'}></i> {dropdown.label || 'Settings'} <i className="fas fa-caret-down ml-1"></i>
            </Link>
            <div className="dropdown-menu tx-13">
              {dropdown.items.map((item, idx) => (
                <button 
                    key={idx} className="dropdown-item" 
                    onClick={item.onClick}
                    disabled={item.disabled}
                    title={item.title || ''}
                >
                  <i className={`${item.icon} mr-2`}></i> {item.label}
                </button>
              ))}
            </div>
          </>
        )}
      </div>



       <div className="btn-icon-list small-display">
        {primaryButtons.map((btn, index) => (
          <a key={index} className={`btn ripple btn-icon ${btn.className}`} href={btn.href || "#"} onClick={btn.onClick}>
            <i className={`${btn.icon}`}></i>
          </a>
        ))}

        {dropdown && (
          <>
            <Link
              className={`btn ripple btn-icon ${dropdown.buttonClass || 'btn-danger'} dropdown-toggle`}
              to="#"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <i className={dropdown.icon || 'fe fe-settings'}></i>
            </Link>
            <div className="dropdown-menu tx-13">
              {dropdown.items.map((item, idx) => (
                <button 
                    key={idx} className="dropdown-item" 
                    onClick={item.onClick}
                    disabled={item.disabled}
                    title={item.title || ''}
                >
                  <i className={`${item.icon} mr-2`}></i> {item.label}
                </button>
              ))}
            </div>
          </>
        )}
      </div>


    </div>
    {/** Only show where license billing is relevant and  current page is not /license */}
    {licenseInfo && currentPage !== '/license' && <LicenseBillingAlert
            show={!!unpaidInvoice}
            amount={unpaidInvoice?.amount}
            currency={licenseInfo?.licenseSummary?.currency}
            dueDate={licenseInfo?.licenseSummary?.licenseValidUntil}
            graceUntil={licenseInfo?.licenseSummary?.graceUntil}
          />}
      {currentNotify}
    </>
  );
};

export default PageHeader;
